<template>
  <div class="basicInfo">
    <el-row class="flow-wrap" :gutter="25">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-button
          type="primary"
          class="button-size"
          @click="handleDetail"
          v-if="
            hasPerm('/meminfo/selectAllParents') &&
            this.parentInfoArr[8] &&
            this.parentInfoArr[8].phoneNumber
          "
          >层级列表
        </el-button>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          真实姓名：<span>{{ userInfoObj.realName || "未实名" }}</span>
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          用户等级：<span v-if="seat">{{ seat }} - </span
          ><span>{{ userInfoObj.levelName }}</span>
          <span v-if="userInfoObj.validityDate"
            >({{ userInfoObj.validityDate }})</span
          >
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          手机号码：<span>{{ userInfoObj.phoneNumber }}</span>
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          身份证号：<span>{{
            isAgent ? doUnicode(userInfoObj.idCard) : userInfoObj.idCard
          }}</span>
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          注册时间：<span>{{ userInfoObj.createTime }}</span>
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          所属地区：<span>{{ userInfoObj.area }}</span>
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          实名认证时间：<span>{{ userInfoObj.authTime }}</span>
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          IP地址：<span>{{ userInfoObj.ipAddr }}</span>
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          最后登录时间：<span>{{ userInfoObj.loginTime }}</span>
        </p>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          手机型号：<span>{{
            userInfoObj.phoneSysType == "0" ? "IOS" : "Android"
          }}</span>
        </p>
      </el-col>
      <el-col
        :xs="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
        v-for="(parentInfo, index) in parentInfoArr"
        :key="index"
        v-if="parentInfoArr.length"
      >
        <p>
          {{ parentInfo.name }}：<span v-if="parentInfo.firstLevelNameZ"
            >{{ parentInfo.firstLevelNameZ }} - </span
          ><span
            >{{ parentInfo.levelName }} {{ parentInfo.phoneNumber }}
            {{ parentInfo.realName }}
            {{ parentInfo.id }}</span
          >
        </p>
      </el-col>
    </el-row>
    <show-info-dialog ref="infoDialog" title="用户层级" :show="true">
      <p v-for="(parentInfo, index) in personList" :key="index">
        {{ parentInfo.name }}：<span v-if="parentInfo.firstLevelNameZ"
          >{{ parentInfo.firstLevelNameZ }} - </span
        ><span
          >{{ parentInfo.id }} {{ parentInfo.levelName }}
          {{ parentInfo.phoneNumber }} {{ parentInfo.realName }}</span
        >
      </p>
    </show-info-dialog>
  </div>
</template>

<script>
import privateKey from "service/constant/privateKey";
import MemberService from "service/MemberService";
import ShowInfoDialog from "@/view/dialog/ShowInfoDialog";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "BasicInfo",
  data() {
    return {
      userInfoObj: {},
      parentInfoArr: [],
      personList: [],
      seat: "",
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.getDetail();
  },
  components: { ShowInfoDialog },
  computed: {
    isAgent() {
      return this.userInfo.roleId == 7;
    },
    ...mapGetters(["serverType", "tatId", "userInfo"]),
  },
  methods: {
    getDetail() {
      const params = {
        id: this.$route.params.id,
        simpleTatId: this.$route.params.simpleTatId,
      };

      this.doLoad(
        MemberService.selectOne,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            this.userInfoObj = res.contents.memInfo;
            this.seat = this.userInfoObj.seating;
            this.parentInfoArr = res.contents.parentInfo;
            // console.log(this.parentInfoArr);
          });
        },
        "信息获取失败"
      );
    },
    handleDetail() {
      const params = {
        id: this.$route.params.id,
        simpleTatId: this.$route.params.simpleTatId,
      };

      this.doLoad(
        MemberService.selectAllParents,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            this.personList = res.contents;
            this.$refs.infoDialog.open();
          });
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>
.basicInfo p {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  margin-bottom: 30px;
}

.basicInfo p span {
  font-weight: normal;
}

.basicInfo p span.blue {
  color: rgba(7, 154, 222, 1);
}

.button-size {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/fragment/MemberManage/BasicInfo.vue